import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { User, Mail, Lock } from 'lucide-react';

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });
  const { login, register, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/meus-ebooks');
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isLogin) {
        await login(formData.email, formData.password);
        toast.success('Login realizado com sucesso!');
      } else {
        await register(formData.name, formData.email, formData.password);
        toast.success('Cadastro realizado com sucesso!');
      }
      navigate('/');
    } catch (error) {
      toast.error('Erro ao processar solicitação');
    }
  };

  return (
    <div style={{ 
      background: 'var(--bg-page)', 
      minHeight: '100vh', 
      paddingTop: '120px',
      paddingBottom: '64px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div className="container" style={{ maxWidth: '500px' }}>
        <div className="network-card" style={{ padding: '40px' }}>
          <h1 className="heading-1" style={{ textAlign: 'center', marginBottom: '8px' }}>
            {isLogin ? 'Bem-vindo de volta!' : 'Crie sua conta'}
          </h1>
          <p className="body-medium" style={{ textAlign: 'center', marginBottom: '32px', color: 'var(--text-secondary)' }}>
            {isLogin ? 'Entre para acessar seus e-books' : 'Cadastre-se para começar sua transformação'}
          </p>

          <form onSubmit={handleSubmit}>
            {!isLogin && (
              <div style={{ marginBottom: '20px' }}>
                <label className="body-small" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                  <User size={16} style={{ display: 'inline', marginRight: '6px' }} />
                  Nome Completo
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '14px 20px',
                    borderRadius: '25px',
                    border: '2px solid var(--border-medium)',
                    fontSize: '16px',
                    outline: 'none',
                    transition: 'border-color 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = 'var(--brand-dark)'}
                  onBlur={(e) => e.target.style.borderColor = 'var(--border-medium)'}
                />
              </div>
            )}

            <div style={{ marginBottom: '20px' }}>
              <label className="body-small" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                <Mail size={16} style={{ display: 'inline', marginRight: '6px' }} />
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '14px 20px',
                  borderRadius: '25px',
                  border: '2px solid var(--border-medium)',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => e.target.style.borderColor = 'var(--brand-dark)'}
                onBlur={(e) => e.target.style.borderColor = 'var(--border-medium)'}
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label className="body-small" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                <Lock size={16} style={{ display: 'inline', marginRight: '6px' }} />
                Senha
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                minLength={6}
                style={{
                  width: '100%',
                  padding: '14px 20px',
                  borderRadius: '25px',
                  border: '2px solid var(--border-medium)',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => e.target.style.borderColor = 'var(--brand-dark)'}
                onBlur={(e) => e.target.style.borderColor = 'var(--border-medium)'}
              />
            </div>

            <button type="submit" className="btn-primary" style={{ width: '100%', marginBottom: '20px' }}>
              {isLogin ? 'Entrar' : 'Cadastrar'}
            </button>
          </form>

          <div style={{ textAlign: 'center' }}>
            <p className="body-small">
              {isLogin ? 'Não tem uma conta?' : 'Já tem uma conta?'}
              {' '}
              <button
                onClick={() => setIsLogin(!isLogin)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'var(--brand-dark)',
                  fontWeight: '600',
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
              >
                {isLogin ? 'Cadastre-se' : 'Faça login'}
              </button>
            </p>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <Link to="/" style={{ color: 'var(--brand-dark)', textDecoration: 'none', fontWeight: '500' }}>
            ← Voltar para página inicial
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;